module.exports = __webpack_public_path__ + "static/media/yahoo.5f9a7798.svg";